/**
 * GF hero сервис-страницы (.gf-hero): фото-фон + скрим + h1/sub + CTA-ряд.
 * Разметка была скопирована 1:1 в 6 *PageContent (vpn/insurance/transport/tours/esim/stay);
 * различалось только содержимое .gf-hero-cta — оно передаётся children.
 *
 * @param {string}          background фон (URL); фолбэк — /images/hero.webp (как было во всех копиях)
 * @param {React.ReactNode} [media]    анимированный фон-слой; если задан — рендерится вместо <img> (background остаётся фолбэком)
 * @param {string}          title      h1 (он же alt фото)
 * @param {string}          [sub]      подзаголовок .gf-hero-sub
 * @param {React.ReactNode} [children] содержимое .gf-hero-cta; если falsy — ряд CTA не рендерится
 */
export default function GfVerticalHero({ background, media, title, sub, children }) {
    const heroBg = background || '/images/hero.webp';
    // локальные пастельные иллюстрации (/images/hero/*) — светлый режим:
    // белый градиент вместо тёмного скрима, текст в чернила
    const lite = !media && heroBg.startsWith('/images/hero/');
    return (
        <section className={`gf-hero${lite ? ' gf-hero--lite' : ''}`}>
            <div className="gf-hero-photo">
                {media || <img src={heroBg} alt={title} />}
                <div className="scrim" />
            </div>
            <div className="gf-hero-in">
                <h1>{title}</h1>
                {sub && <p className="gf-hero-sub">{sub}</p>}
                {children && <div className="gf-hero-cta">{children}</div>}
            </div>
        </section>
    );
}
